import * as React from 'react'

const Button = () => {
  return (
    <a
      href="https://mathieudutour673292.typeform.com/to/imotLy"
      title="Register Interest"
      style={{ textDecoration: 'none', color: '#282828' }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="119.66407"
        height="40"
        viewBox="0 0 213 63"
      >
        <defs>
          <linearGradient
            id="android-a"
            x1="60.352%"
            x2="27.91%"
            y1="4.95%"
            y2="71.926%"
          >
            <stop offset="0%" stopColor="#00A0FF" />
            <stop offset=".657%" stopColor="#00A1FF" />
            <stop offset="26.01%" stopColor="#00BEFF" />
            <stop offset="51.22%" stopColor="#00D2FF" />
            <stop offset="76.04%" stopColor="#00DFFF" />
            <stop offset="100%" stopColor="#00E3FF" />
          </linearGradient>
          <linearGradient
            id="android-b"
            x1="107.63%"
            x2="-130.552%"
            y1="50%"
            y2="50%"
          >
            <stop offset="0%" stopColor="#FFE000" />
            <stop offset="40.87%" stopColor="#FFBD00" />
            <stop offset="77.54%" stopColor="orange" />
            <stop offset="100%" stopColor="#FF9C00" />
          </linearGradient>
          <linearGradient
            id="android-c"
            x1="86.243%"
            x2="-50.129%"
            y1="30.982%"
            y2="135.669%"
          >
            <stop offset="0%" stopColor="#FF3A44" />
            <stop offset="100%" stopColor="#C31162" />
          </linearGradient>
          <linearGradient
            id="android-d"
            x1="-18.811%"
            x2="42.085%"
            y1="-11.645%"
            y2="35.13%"
          >
            <stop offset="0%" stopColor="#32A071" />
            <stop offset="6.85%" stopColor="#2DA771" />
            <stop offset="47.62%" stopColor="#15CF74" />
            <stop offset="80.09%" stopColor="#06E775" />
            <stop offset="100%" stopColor="#00F076" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
          <path
            fill="#FFF"
            fillRule="nonzero"
            d="M205.108 63H7.892C3.542 63 0 59.45 0 55.125V7.875C0 3.535 3.542 0 7.892 0h197.216C209.454 0 213 3.535 213 7.875v47.25c0 4.324-3.546 7.875-7.892 7.875z"
          />
          <path
            fill="#A6A6A6"
            d="M205.108 1.26c3.648 0 6.634 2.974 6.634 6.615v47.25c0 3.641-2.966 6.614-6.634 6.614H7.892c-3.648 0-6.634-2.973-6.634-6.614V7.875c0-3.641 2.966-6.614 6.634-6.614h197.216zm0-1.26H7.892C3.542 0 0 3.55 0 7.875v47.25C0 59.465 3.542 63 7.892 63h197.216c4.346 0 7.892-3.535 7.892-7.875V7.875C213 3.551 209.454 0 205.108 0z"
          />
          <path
            opacity="0.4"
            fill="#000"
            fillRule="nonzero"
            d="M112.127 20c-1.415 0-2.607-.49-3.55-1.454a4.924 4.924 0 0 1-1.435-3.548c0-1.408.484-2.6 1.434-3.544.94-.964 2.132-1.454 3.547-1.454 1.399 0 2.591.49 3.55 1.454.95.976 1.434 2.167 1.434 3.544-.016 1.412-.499 2.603-1.434 3.544-.94.972-2.132 1.458-3.546 1.458zm-42.092 0c-1.383 0-2.584-.482-3.566-1.435-.974-.948-1.469-2.148-1.469-3.563s.495-2.615 1.47-3.564c.962-.952 2.162-1.434 3.565-1.434.686 0 1.352.135 1.991.409.628.266 1.138.628 1.516 1.072l.094.112-1.056 1.025-.11-.127c-.596-.702-1.395-1.045-2.45-1.045-.944 0-1.766.332-2.444.987-.682.66-1.029 1.524-1.029 2.569s.347 1.909 1.029 2.568c.678.656 1.5.988 2.443.988 1.006 0 1.851-.332 2.51-.988.39-.385.631-.925.717-1.608H69.86v-1.442h4.84l.02.13c.034.244.07.494.07.726 0 1.33-.406 2.406-1.209 3.2-.912.942-2.104 1.42-3.546 1.42zM126 19.796h-1.493l-4.57-7.24.038 1.304v5.932h-1.492v-9.584h1.703l.046.074 4.299 6.818-.04-1.3v-5.592H126v9.588zm-25.089 0h-1.512V11.65h-2.623v-1.443h6.754v1.443h-2.623v8.145h.004zm-5.366 0h-1.508v-9.588h1.508v9.588zm-8.476 0H85.56V11.65h-2.623v-1.443h6.753v1.443h-2.62v8.145zm-5.086-.016H76.2v-9.572h5.783v1.443h-4.27v2.63h3.853v1.427h-3.854v2.63h4.271v1.442zm27.7-2.225a3.355 3.355 0 0 0 2.444 1.003c.978 0 1.777-.328 2.443-1.003.663-.656.998-1.516.998-2.553s-.335-1.901-.994-2.553a3.361 3.361 0 0 0-2.443-1.003c-.979 0-1.778.328-2.44 1.003-.663.656-.998 1.516-.998 2.553s.332 1.901.99 2.553z"
          />
          <path
            opacity="0.4"
            fill="#000"
            d="M106.48 34.486c-3.699 0-6.697 2.834-6.697 6.743 0 3.874 3.018 6.743 6.697 6.743 3.698 0 6.696-2.853 6.696-6.743 0-3.909-2.998-6.743-6.696-6.743zm0 10.814c-2.024 0-3.765-1.691-3.765-4.087 0-2.43 1.745-4.087 3.765-4.087 2.023 0 3.765 1.657 3.765 4.087.003 2.412-1.742 4.087-3.765 4.087zM91.87 34.486c-3.699 0-6.697 2.834-6.697 6.743 0 3.874 3.018 6.743 6.697 6.743 3.698 0 6.696-2.853 6.696-6.743 0-3.909-3.002-6.743-6.696-6.743zm0 10.814c-2.024 0-3.765-1.691-3.765-4.087 0-2.43 1.745-4.087 3.765-4.087 2.023 0 3.765 1.657 3.765 4.087 0 2.412-1.742 4.087-3.765 4.087zm-17.385-8.755V39.4h6.782c-.207 1.601-.732 2.783-1.534 3.593-.994 1.004-2.528 2.095-5.232 2.095-4.169 0-7.429-3.4-7.429-7.609 0-4.21 3.26-7.608 7.429-7.608 2.25 0 3.89.897 5.107 2.043l2.004-2.024C79.92 28.253 77.67 27 74.516 27 68.798 27 64 31.704 64 37.462c0 5.775 4.794 10.463 10.516 10.463 3.088 0 5.405-1.02 7.237-2.94 1.866-1.886 2.457-4.546 2.457-6.693 0-.667-.05-1.268-.156-1.778H74.48c.004-.004.004.031.004.031zm71.108 2.222c-.56-1.514-2.25-4.297-5.718-4.297-3.436 0-6.293 2.732-6.293 6.743 0 3.787 2.826 6.744 6.626 6.744 3.053 0 4.83-1.886 5.561-2.993l-2.266-1.533c-.751 1.126-1.796 1.865-3.28 1.865-1.498 0-2.547-.687-3.244-2.043l8.927-3.735c0 .004-.313-.751-.313-.751zm-9.103 2.253c-.07-2.605 2.004-3.93 3.487-3.93 1.17 0 2.145.582 2.477 1.428l-5.964 2.502zm-7.252 6.533h2.931v-19.81h-2.931v19.81zm-4.814-11.569h-.106c-.661-.794-1.917-1.514-3.522-1.514-3.33 0-6.399 2.96-6.399 6.763 0 3.787 3.053 6.712 6.399 6.712 1.585 0 2.86-.724 3.522-1.534h.106v.968c0 2.574-1.362 3.96-3.558 3.96-1.796 0-2.911-1.303-3.365-2.394l-2.548 1.075c.732 1.778 2.685 3.98 5.91 3.98 3.436 0 6.348-2.043 6.348-7.028V34.874h-2.771v1.11h-.016zm-3.366 9.316c-2.023 0-3.714-1.707-3.714-4.067 0-2.38 1.69-4.103 3.714-4.103 2.004 0 3.558 1.744 3.558 4.103.02 2.36-1.55 4.067-3.558 4.067zm38.26-17.557h-7.009v19.81h2.932v-7.502h4.082c3.244 0 6.434-2.375 6.434-6.146 0-3.77-3.178-6.162-6.438-6.162zm.087 9.542h-4.168v-6.799h4.168c2.195 0 3.436 1.83 3.436 3.4 0 1.553-1.256 3.399-3.436 3.399zm18.1-2.834c-2.128 0-4.324.952-5.232 3.027l2.599 1.091c.56-1.09 1.585-1.462 2.669-1.462 1.519 0 3.053.917 3.088 2.553v.21c-.525-.3-1.675-.76-3.053-.76-2.806 0-5.651 1.55-5.651 4.455 0 2.66 2.301 4.368 4.865 4.368 1.968 0 3.052-.897 3.73-1.937h.105v1.534h2.826v-7.59c0-3.533-2.599-5.49-5.945-5.49zm-.367 10.85c-.959 0-2.301-.475-2.301-1.692 0-1.534 1.675-2.115 3.103-2.115 1.292 0 1.902.28 2.67.668-.212 1.779-1.7 3.123-3.472 3.138zm16.621-10.427l-3.365 8.592h-.106l-3.487-8.592h-3.155l5.233 12.011-2.982 6.676h3.052L197 34.874h-3.24zm-26.386 12.68h2.932v-19.81h-2.932v19.81z"
          />
          <path
            opacity="0.4"
            fill="url(#android-a)"
            d="M16.706 12.107c-.448.498-.706 1.258-.706 2.254v35.298c0 .995.258 1.756.721 2.234l.12.107L36 32.223v-.442L16.825 12l-.12.107z"
          />
          <path
            opacity="0.4"
            fill="url(#android-b)"
            d="M42.508 39L36 32.237v-.474L42.508 25l.141.09 7.698 4.547c2.204 1.29 2.204 3.42 0 4.726L42.65 38.91l-.141.09z"
          />
          <path
            opacity="0.4"
            fill="url(#android-c)"
            d="M43 38.564L36.422 32 17 51.383c.711.76 1.904.845 3.236.104L43 38.564"
          />
          <path
            opacity="0.4"
            fill="url(#android-d)"
            d="M43 24.432L20.236 11.52c-1.332-.76-2.529-.656-3.236.104L36.422 31 43 24.432z"
          />
          <path
            fill="#000"
            fillRule="nonzero"
            d="M42.845 38L20.236 51.226c-1.262.748-2.389.696-3.116.016l-.12.124.12.108c.727.676 1.854.732 3.116-.016L43 38.144 42.845 38z"
            opacity=".2"
          />
          <path
            fill="#000"
            fillRule="nonzero"
            d="M50.457 33.846L43 37.872l.134.128 7.305-3.948C51.486 33.485 52 32.741 52 32c-.063.68-.596 1.325-1.543 1.846z"
            opacity=".12"
          />
          <path
            fill="#FFF"
            d="M19.952 11.752L50.37 28.98c.988.555 1.544 1.28 1.63 2.021 0-.81-.537-1.625-1.63-2.246L19.952 11.527C17.77 10.282 16 11.322 16 13.807v.226c0-2.49 1.77-3.51 3.952-2.28z"
            opacity=".25"
          />
        </g>
      </svg>
      <span
        style={{
          textTransform: 'uppercase',
          position: 'relative',
          fontSize: 10,
          bottom: -10,
          left: -95,
          opacity: 0.8,
        }}
      >
        Coming Soon
      </span>
    </a>
  )
}

export default Button
